<template>
  <FiltersItem>
    <template #title>
      {{ $l('global.simplePhrases.climateCompensation') }}
    </template>
    <template #content>
      <FiltersItemContent>
        <template #content>
          <BaseToggle
            :text="$l('showresult.filter.showClimateCompensationDesktop')"
            :checked="isShowClimateCompensationEnabled"
            @update:checked="onToggleClimateCompensation"
          />
          <BaseToggle
            :text="$l('showresult.filter.sortEmission')"
            :checked="filtersStore.state.isSortByLowestEmissionsEnabled"
            @update:checked="onToggleSorting"
          />
        </template>
      </FiltersItemContent>
    </template>
  </FiltersItem>
</template>

<script setup>
import { EventDispatcher } from '@utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
const { urlVars: { sorting }, defaultSorting: _defaultSorting } = js_params;

const currentSorting = ref(sorting || _defaultSorting);
const previousSorting = ref(_defaultSorting);


const filtersStore = useFiltersStore();

const isShowClimateCompensationEnabled = computed(() => filtersStore.state.climateCompensated);

function onToggleClimateCompensation () {
	filtersStore.set({ key: 'climateCompensated', value: filtersStore.state.climateCompensated ? null : true });
}

EventDispatcher.addEventListener('updateFiltersSorting', (event) => {
	previousSorting.value = currentSorting.value;
	currentSorting.value = event;
	filtersStore.set({ key: 'isSortByLowestEmissionsEnabled', value: event === 'emission' });
});

function onToggleSorting () {
	const sorting = filtersStore.state.isSortByLowestEmissionsEnabled ? previousSorting.value : 'emission';
	window.showresult.updateSorting(sorting);
}
</script>

<style lang="scss" scoped>
img {
	display: none;
	margin-left: 0.2rem;
	aspect-ratio: 1/1;

	@include breakpoint_up(md) {
		height: 3.2rem;
		margin-top: 0.1rem;
		display: block;
	}
}
</style>
